import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-exam-input-form',
  templateUrl: './exam-input-form.component.html',
  styleUrls: ['./exam-input-form.component.scss']
})
export class ExamInputFormComponent implements OnInit {
  submitButton= true;
  editButton= false;
  ShowTbl = false;
  deleteReadOnly=false;
  dropdowndisable=false;
  filteredListCourse: any;
  CourseList: any;
  show = false;
  Branches = false;
  examInputForm: FormGroup;
  examList: any;
  ListOfReg: any;
  filteredListOfReg: any;
  dialogRef: MatDialogRef<any>;
  SubArray: FormArray;
  assignTableData: any[];
  errMsg: any;
  submitpayload: any;
  EcId: any;
  RgId: any;
  subjectList: any[];
  filteredSubjectList: any[];
  stream: any;
  streamList: any;
  filteredStreamList: any;
  SessionNo: any;
  Subjects: any[];
  SubCode: any[];
  EsID: any[];
  atdstatus: boolean;
  userPermission: any;
  isCollege: boolean = false;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.fetchList(this.SessionNo);
    }
    window.scroll(0,0)
    this.ShowTbl = false;
    this.Branches = false;
    this.examInputForm = this.fb.group({
      SCgCode:new FormControl(''),
      SValid:new FormControl(''),
      SApp:new FormControl(''),
      SChng:new FormControl(''),
      CSExBr: new FormControl(''),
      Code: new FormControl(''),
      Colg: new FormControl(''),
      valid: new FormControl(''),
      changed: new FormControl(''),
      Batch: new FormControl(''),
      Name: new FormControl(''),
      RgNo: new FormControl(0),
      FormNo: new FormControl(''),
      CgCode: new FormControl(''),
      Chng: new FormControl(''),
      Valid: new FormControl(''),
      Father: new FormControl(''),
      Mother: new FormControl(''),
      BirthDate: new FormControl(''),
      Sex: new FormControl('M'),
      Cate: new FormControl('2'),
      Caste: new FormControl(''),
      EMail: new FormControl(''),
      Medium: new FormControl('English'),
      Nation: new FormControl('In'),
      Mobile: new FormControl(''),
      Addr1: new FormControl(''),
      Addr2: new FormControl(''),
      Addr3: new FormControl(''),
      Addr1P: new FormControl(''),
      Addr2P: new FormControl(''),
      Addr3P: new FormControl(''),
      Pin: new FormControl(''),
      PinP: new FormControl(''),
      Place: new FormControl(''),
      PlaceP: new FormControl(''),
      ExSub: new FormControl(''),
      Sub: new FormControl(''),
      EcId: new FormControl('',Validators.required),
      CgCodee: new FormControl(''),
      CoCode: new FormControl(''),
      SnNo: new FormControl(this.SessionNo),
      EmId: new FormControl(''),
      App: new FormControl(''),
      RgId: new FormControl(''),
      StrId: new FormControl(''),
      RgName: new FormControl(''),
      SrNo: new FormControl(''),
      EmCode: new FormControl(''),
      FNR: new FormControl(''),
      PrefCent: new FormControl(''),
      IncMarks: new FormControl(''),
      strCode: new FormControl(''),
      Excp: new FormControl(''),
      Decl: new FormControl(''),
      Cent: new FormControl(''),
      RollNo: new FormControl(''),
      ProcFlag: new FormControl(''),
      Mesg: new FormControl(''),
      Efid: new FormControl(''),
      RgSex: new FormControl(''),
      ClassRoll: new FormControl(''),
      Seme: new FormControl(''),
      MaxSeme: new FormControl(''),
      CgName: new FormControl(''),
      OptSub: new FormControl(''),
      SubArray: new FormArray([]),
    });

    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.getCollegeData(this.userPermission);
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo'];
      this.fetchList(this.SessionNo);
      }
    );
  }

  getSubArrayControls() {
    return (this.examInputForm.get('SubArray') as FormArray).controls;
  }

  addNewRow() {
    const creds = this.examInputForm.controls.SubArray as FormArray;
    creds.push(
      this.fb.group({
        EsType: new FormControl(''),
        SrNo: new FormControl(''),
        EsId: new FormControl(''),
        Head: new FormControl(''),
        Marks: new FormControl(''),
        NewSub: new FormControl(''),
        Sub: new FormControl(''),
        App: new FormControl(''),
      })
    );
  }

  fetchCourseCode() {
    const payload = {};
    this.umsService.getCourse(payload).subscribe((res) => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      } else {
      }
    });
  }

  fetchList(SnNo) {
    let payload = {};
    payload['SnNo'] = SnNo;
    payload['InCode'] = 19;
    payload['OpId'] = parseInt(sessionStorage.getItem('userId'));
    this.umsService.fetchExamRegList(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfReg = res.data;
        this.filteredListOfReg = this.ListOfReg.slice();
        this.ShowTbl = false
      } else {
        this.ShowTbl = false
      }
    });
  }


  selectedList(e){
    // this.ShowTbl = true;
    this.examInputForm.controls['EmId'].setValue(e.EmId);
    this.examInputForm.controls['EcId'].setValue(e.EcId);
  this.show = false;
  this.ShowTbl = false;
  }

  generateExams(){
    if(this.examInputForm.controls['EcId'].valid){
      let SubmittedData = this.examInputForm.value;
      const payload = {};
      payload['LoginId'] = sessionStorage.getItem('userId');
      payload['EmId'] = SubmittedData['EmId'];
      payload['CgCode'] = ''
      payload['Branch'] = ''
      payload['Cate'] = 'A'
      payload['RgNo'] = ''
      payload['ForSnNo'] = ''
      payload['SoftCopy'] = ''
      payload['EcId'] =  SubmittedData['EcId']
      payload['Inst'] = this.umsService.secretdata['ClubPartTrans']
      this.spinner.show();
      this.umsService.generateExams(payload).subscribe((res) => {
        this.spinner.hide()
        if(res.status == true && res.message != "No new form generated"){
          this.validateGeneratedExams(payload);
        }
        else if(res.status == true && res.message == "No new form generated"){
          let data = {};
          data['message'] = res.message
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
        
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.dialogRef.afterClosed().subscribe(result => {
          this.searchExams();
        }); 
      });
    }else{
      this.examInputForm.get('EcId').markAsTouched();
    }
    
  }

 
  
  validateGeneratedExams(e){
    let payload = {};
    payload['EcId'] = e.EcId;
    payload['ForRgId'] = 0;
    payload['ForSrNo'] = 0;
    payload['Inst'] = e.Inst;
    payload['LoginId'] = e.LoginId;
    this.umsService.PutvalidateGeneratedExams(payload).subscribe((res) => {
      this.spinner.hide();
          if (res.status) {
            let data = {};
            data['message'] = res.message;
            data['title'] = 'Information';
            data['icon'] = 'fas fa-check';
            this.dialogRef =
              this.modalPopupService.openPopup<AlertBoxComponent>(
                AlertBoxComponent,
                data
              );
          }
          this.dialogRef.afterClosed().subscribe(result => {
            this.searchExams();
          }); 
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  searchExams(){
   let SubmittedData = this.examInputForm.value;
   let payload = {};
   payload['EcId'] =  SubmittedData['EcId'];
   payload['CgCode'] =  SubmittedData['SCgCode'];
   payload['Valid'] =  SubmittedData['SValid'];
   payload['Chng'] = SubmittedData['SChng'];
   payload['App'] =  SubmittedData['SApp'];
   payload['EfId'] =  0
    this.umsService.fetchInputExams(payload).subscribe((res) => {
      if (res.status) {
        this.ShowTbl = true;
       this.examList = res.data;
       this.getBranch(res.data[0]['EmId'])
      //  this.fetchStudentAttd(res.data[0]['StuId'],res.data[0]['EmId'],res.data[0]['RgCoCode'])
      } else {
        this.ShowTbl = false;
        this.examList = []
        let data = {};
      data['message'] = 'No Record For This Exam';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      }
    });
  }
  prepopulate(exam){
    this.show = true;
    this.examInputForm.controls['RgId'].setValue(exam.RgId)
    this.examInputForm.controls['EmId'].setValue(exam.EmId)
    this.examInputForm.controls['StrId'].setValue(exam.StrId)
    this.examInputForm.controls['RgNo'].setValue(exam.RgNo)
    this.examInputForm.controls['RgName'].setValue(exam.RgName)
    this.examInputForm.controls['CgCode'].setValue(exam.CgCode)
    this.examInputForm.controls['SrNo'].setValue(exam.SrNo)
    this.examInputForm.controls['EmCode'].setValue(exam.EmCode)
    this.examInputForm.controls['FNR'].setValue(exam.FNR)
    this.examInputForm.controls['Cate'].setValue(exam.Cate)
    this.examInputForm.controls['App'].setValue(exam.App)
    this.examInputForm.controls['PrefCent'].setValue(exam.PrefCent)
    this.examInputForm.controls['IncMarks'].setValue(exam.IncMarks)
    this.examInputForm.controls['strCode'].setValue(exam.strCode)
    this.examInputForm.controls['Excp'].setValue(exam.Excp)
    this.examInputForm.controls['Decl'].setValue(exam.Decl)
    this.examInputForm.controls['RollNo'].setValue(exam.RollNo)
    this.examInputForm.controls['ProcFlag'].setValue(exam.ProcFlag)
    this.examInputForm.controls['Valid'].setValue(exam.Valid)
    this.examInputForm.controls['Mesg'].setValue(exam.Mesg)
    this.examInputForm.controls['Chng'].setValue(exam.Chng)
    this.examInputForm.controls['Efid'].setValue(exam.Efid)
    this.examInputForm.controls['Caste'].setValue(exam.Caste)
    this.examInputForm.controls['RgSex'].setValue(exam.RgSex)
    this.examInputForm.controls['ClassRoll'].setValue(exam.ClassRoll)
    this.examInputForm.controls['Seme'].setValue(exam.Seme)
    this.examInputForm.controls['MaxSeme'].setValue(exam.MaxSeme)
    this.examInputForm.controls['strCode'].setValue(exam.strCode)
    this.examInputForm.controls['CgName'].setValue(exam.CgName)
    // this.examInputForm.controls['OptSub'].setValue(exam.Sub.split(","))
    let submitpayload = this.examInputForm.value
    this.fetchStudentAttd(exam.StuId,exam.EmId,exam.RgCoCode)
    this.ExmFormSub(submitpayload.EcId,exam.RgId)
    
  }
  
  getBranch(e){
    this.spinner.show();
    let payload = {};
    payload['CoCode'] = 0;
    payload['EmId'] = e;
    this.umsService.getExamStream(payload).subscribe((res) => {
      this.spinner.hide();
      if(res.data.length > 0){
        this.Branches = true;
      }
      else{
        this.Branches = false;
      }
      if (res.status) {
        this.streamList = res.data;
        this.filteredStreamList = this.streamList.slice();
       
        
      }
      else{
        this.fetchSubjectStr(0,e) 
      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getSub(e,code){
    this.stream = e
    this.fetchSubjectStr(e,this.examInputForm['EmId']);
  }

  fetchSubjectStr(Strid,EmID) {
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmID;
    payload['EsStrId'] = Strid;
    this.subjectList = [];    
    this.umsService.listofSubjects(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        let x = [];
        this.subjectList = res.data;
        this.filteredSubjectList = this.subjectList.slice();
        this.subjectList.forEach(element => {
        x.push(element.EsCode);
        });
      
        this.examInputForm.controls['OptSub'].setValue(x);
      } else {
        this.subjectList = [];
        this.filteredSubjectList = this.subjectList.slice();
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  ExmFormSub(EcId, RgId) {
    this.EcId = EcId;
    this.RgId = RgId;
    this.spinner.show();
    const payload = {};
    payload['EcId'] = EcId;
    payload['RgId'] = RgId;
    this.assignTableData = []
    this.SubArray = this.examInputForm.get('SubArray') as FormArray;
    this.SubArray.clear();
    this.umsService.ExmFormSub(payload).subscribe((res) => {
      this.spinner.hide();
      this.assignTableData = []
      if (res.status) {
        this.spinner.hide();
        this.assignTableData = res.data;
        this.SubArray = this.examInputForm.get('SubArray') as FormArray;
        // this.assignTableData.map((element, i) => {
        //   this.SubArray.at(i).get('EsType').setValue(element['EsType']);
        //   this.SubArray.at(i).get('Head').setValue(element['Head']);
        //   this.SubArray.at(i).get('Marks').setValue(element['Marks']);
        //   this.SubArray.at(i).get('NewSub').setValue(element['NewSub']);
        //   this.SubArray.at(i).get('Sub').setValue(element['Sub']);
        //   this.SubArray.at(i).get('App').setValue(element['App']);
        // });

        this.assignTableData.forEach((element, i) => {
          const showDropdown = !element.Head;
          const showYN = element.EsOpCode
          const creds = this.examInputForm.controls.SubArray as FormArray;
          creds.push(
            this.fb.group({
              EsType: new FormControl(element.EsType),
              SrNo: new FormControl(1),
              EsId: new FormControl(element.SEsId),
              EsParent: new FormControl(element.EsParent),
              Head: new FormControl(element.Head),
              Marks: new FormControl(element.Marks),
              NewSub: new FormControl(element.NewSub),
              Sub: new FormControl(element.Sub),
              Pass: new FormControl(''),
              App: new FormControl(element.App),
              showDropdown: new FormControl(showDropdown),
              showYN: new FormControl(showYN)
            })
          );
          let x = (this.examInputForm.get('SubArray') as FormArray).controls;
          x.forEach(element => {
            element['controls']['App'].setValue('Y');
          });

        });
       
      }
      else {
        
        this.spinner.hide();
        this.assignTableData = []
        this.SubArray = this.examInputForm.get('SubArray') as FormArray;
        this.SubArray.clear();
        this.SubArray.push(
          this.fb.group({
            EsType: new FormControl(''),
            SrNo: new FormControl(''),
            EsId: new FormControl(''),
            Head: new FormControl(''),
            Marks: new FormControl(''),
            NewSub: new FormControl(''),
            Sub: new FormControl(''),
            Pass: new FormControl(''),
            App: new FormControl(''),
          })
        );
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SubArray = this.examInputForm.get('SubArray') as FormArray;
        this.SubArray.clear();
      // this.subDataList = []
    })
  }

  Generate() {
    this.SubArray = this.examInputForm.get('SubArray') as FormArray;
    let isPopupShown = false;
    const subjectsToAlert: string[] = [];
    let isAnyControlTouched = false;
    this.SubArray.value.forEach(element => {
        if (element.App === 'N') {
            if (element.EsType === 'S' && !isPopupShown) {
                subjectsToAlert.push(element.Sub); // Store the subject name
                const data = {};
                data['message'] = `You will not be able to appear for the following subjects: ${subjectsToAlert.join(', ')}. Are you sure you want to proceed?`;
                data['title'] = 'Alert';
                data['icon'] = 'fa fa-question';
                this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
                this.dialogRef.afterClosed().subscribe(result => {
                    if (result === 'yes') {
                      
                        this.saveExamForm();
                    } else {
                      
                    }
                });
    
                isPopupShown = true;
            }
            isAnyControlTouched = true;
            
        }
        else{
          isAnyControlTouched = false;
        }
        // else{
        //   this.saveExamForm();
        // }
    });
    if( isAnyControlTouched == false && isPopupShown == false){
      this.saveExamForm();
    }
    
  }

  saveExamForm(){
    this.spinner.show();
    this.submitpayload = this.examInputForm.value;
    let abcd = this.examInputForm.get('SubArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            EcId: new FormControl(this.EcId),
            RgId: new FormControl(this.RgId),
            SrNo: new FormControl(element.SrNo),
            EsId: new FormControl(element.EsId),
            App: new FormControl(element.App),
          })
        )
        this.umsService.SaveExmFrm(arr1[0].value).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    });

    // let payload = {};
    // payload['EcId'] = 
    // payload['RgId'] = 
    // payload['SrNo'] = 
    // payload['EsId'] = 
    // payload['App'] = 
    // this.umsService.SaveExmFrm(payload).subscribe((res) => {
    //   if (res.status) {
        
    //   }
    // })
  }


  keypress() {
    // this.umsService.getExam(this.examDataSearchForm.value).subscribe(
    //   (res) => {
    //     this.examList = [];
    //     this.examList = res.data;
    //   }, (ERROR: HttpErrorResponse) => {
    //     this.examList = [];
    //   });
  }
  print(){
    let submitpayload = this.examInputForm.value;
    let payload1 = {}
    payload1['MenuName'] = 'Exam-Form';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 118,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  redirect(to): void {
    this.router.navigate([to]);
  }

  isVisible(subData: FormArray): boolean {
    const esTypeToShow = 'S'; // Set the EsType you want to show
    return subData.get('EsType').value === esTypeToShow;
}

checkvalidattion(subData,i){
  let abcd = this.examInputForm.get('SubArray') as FormArray;
    let payload = abcd.value;
  if(subData.value.showYN == ' ' || subData.value.showYN == null){
    if(subData.value.EsType == 'P'){
      if(payload[i-1].showYN == ' ' || payload[i-1].showYN == null){
        return true
      }
      else{
        return false
      }
    }
    else{
      return true
    }
  }
  else{
    return false;
  }

  // If no adjacent subject has data in showYN, disable the current subject
  
}

fetchStudentAttd(StuId, EmId, CoCode) {
  const payload = {};
  this.Subjects = [];
  this.SubCode = [];
  this.EsID = [];
  this.atdstatus = false;
  payload['StuID'] = StuId;
  payload['EmId'] = EmId;
  payload['SessionID'] = this.SessionNo;
  this.umsService.StuAttendance(payload).subscribe((res) => {
    if (res.status) {
      let attendanceData = res.data[0]
      res.data[0].forEach(element => {
        if(element.AttendStatus == 'N' || element.AttendStatus == null){
          const isDuplicate = this.Subjects.some((item: any) => item === element.EsName);
          if (!isDuplicate) {
            this.Subjects.push(element.EsName)
            this.SubCode.push(element.EsCode)
            this.EsID.push(element.EsId);
          }
         
        }
      });
      this.SubArray = this.examInputForm.get('SubArray') as FormArray;
      this.SubCode.forEach(element => {
        this.SubArray.value.forEach((element2, index) => {
          if(element2['EsType'] == 'S'){
            if(element2['Sub'] == element){
              this.SubArray.at(index).get('App').setValue('N');
              // this.cdr.detectChanges();
            }
            
          }
          if(element2['EsType'] == 'P'){
            this.EsID.forEach(element3 => {
              if(element3 == element2['EsParent']){
                this.SubArray.at(index).get('App').setValue('N');
              }
            });
            
         
          }
        });
       
      });
     
    
      if (res.data[0].find(item => item.AttendStatus === 'N')) {
        this.atdstatus = true
        let data = {}
        data['message'] = "Attendance Is Less For " + this.Subjects + " Subjects"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.fetchStudentIAAtd(StuId, EmId, CoCode);
        });
      }
      else{
        // this.submitFeeTemplet()
        // this.saveExamForm();
        this.fetchStudentIAAtd(StuId, EmId, CoCode);

      }

    } else {
      //this.apimicroservice.openSnackbar(res.message);
    }
  }, (ERROR: HttpErrorResponse) => {
    this.NewSemAtd(StuId, EmId, CoCode);
  });
}

NewSemAtd(StuId, EmId, CoCode){
  const payload = {};
  this.Subjects = [];
  this.SubCode = [];
  this.EsID = [];
  this.atdstatus = false;
  payload['StuID'] = StuId;
  payload['EmId'] = EmId;
  payload['SessionID'] = this.SessionNo;
  payload['CoCode'] = CoCode
  this.umsService.StuAttendanceNewSem(payload).subscribe((res) => {
    if (res.status) {
      let attendanceData = res.data[0]
      res.data[0].forEach(element => {
        if(element.AttendStatus == 'N'){
          this.Subjects.push(element.EsName)
          this.SubCode.push(element.EsCode)
          this.EsID.push(element.EsId);
         
        }
      });
      this.SubArray = this.examInputForm.get('SubArray') as FormArray;
      this.SubCode.forEach(element => {
        this.SubArray.value.forEach((element2, index) => {
          if(element2['EsType'] == 'S'){
            if(element2['Sub'] == element){
              this.SubArray.at(index).get('App').setValue('N');
              // this.cdr.detectChanges();
            }
            
          }
          if(element2['EsType'] == 'P'){
            this.EsID.forEach(element3 => {
              if(element3 == element2['EsParent']){
                this.SubArray.at(index).get('App').setValue('N');
              }
            });
            
         
          }
        });
       
      });
     
    
      if (res.data[0].find(item => item.AttendStatus === 'N')) {
        this.atdstatus = true
        let data = {}
        data['message'] = "Attendance Is Less For " + this.Subjects + " Subjects"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.fetchStudentIAAtd(StuId, EmId, CoCode);
        });
      }
      else{
        // this.submitFeeTemplet()
        // this.saveExamForm();
        this.fetchStudentIAAtd(StuId, EmId, CoCode);

      }

    } else {
      //this.apimicroservice.openSnackbar(res.message);
    }
  }, (ERROR: HttpErrorResponse) => {
    let data = {}
    data['message'] = "Attendance Not Available For Subjects"
    data['title'] = 'Information'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  });
}

fetchStudentIAAtd(StuId, EmId, CoCode){
  const payload = {};
  this.Subjects = [];
  payload['SessionId'] = this.SessionNo
  payload['CoCode'] = CoCode;
  payload['EsCode'] = ''
  payload['EsParentId'] = ''
  payload['StuID'] = StuId;
  payload['EmId'] = EmId;
  this.umsService.getIAAtd(payload).subscribe((res) => {
    if (res.status) {
      let attendanceData = res.data[0];
      res.data[0].forEach(element => {
        if(element.AttendStatus == 'N' || element.AttendStatus == null){
          this.Subjects.push(element.EsPSubCode +' - '+ element.EsName)
        }
      });
    
      if (res.data[0].find(item => item.AttendStatus === 'N' || item.AttendStatus === null)) {
        let data = {}
        data['message'] = "Attendance Is Less For " + this.Subjects.join(', ')  
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.saveExamForm();
        });
      }
      else{
        // this.submitFeeTemplet()
        // this.saveExamForm();
      //  this.fetchStudentIAAtd();
        

      }

    } else {
      let data = {}
      data['message'] = "Attendance Not Available For Heads"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      //this.apimicroservice.openSnackbar(res.message);
    }
  }, (ERROR: HttpErrorResponse) => {
    // this.saveExamForm()
    // let data = {}
    // data['message'] = "Attendance Not Available"
    // data['title'] = 'Information'
    // data['icon'] = 'fas fa-close'
    // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  });
}

isAttendanceDeficient(subData): boolean {
  // Check both conditions, replace with actual condition for fees
  let value = false
  let SubjectCode = subData.get('Sub').value
  this.SubCode.forEach(element => {
    if (element === SubjectCode) {
      value = true;
    }
  });
  return value
 
}

getCollegeData(userPermission: any) {
  this.spinner.show();
  let UserCollege = '';
  this.isCollege = false;
  if(userPermission[0].CgUi == 'C'){
    UserCollege = userPermission[0].CgId;
    this.isCollege = true;
  }
  const payload = { 'CgCode': UserCollege };
  this.umsService.getCollege(payload).subscribe(
    (res) => {
      this.spinner.hide();
      const CgName = res.data;
      if(userPermission[0].CgUi == 'C'){
        this.examInputForm.controls['SCgCode'].setValue(CgName[0].CgName);
        // this.isCollege = true;
      }
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      return [];
    }
  );
}
}
